// extracted by mini-css-extract-plugin
export var orderDetails = "_p5-2";
export var orderImage = "_p5-1";
export var orderMeta = "_p5-3";
export var orderSummary = "_p5-0";
export var rightArrow = "_p5-4";